import React from "react";
import styled from "styled-components/macro";
import dropdown from "../../images/dropdown.png";
import { useSelector } from "react-redux";
import { IOSSwitch } from "../UploadFiles/upload_file_choose_properties";
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormControl from "@material-ui/core/FormControl";
import { Snackbar } from "@material-ui/core";
import MuiAlert from "@material-ui/lab/Alert";
import { makeStyles } from "@material-ui/core/styles";
import { useRideUnitContext } from "../../contexts";
import { useSnapshot } from "valtio";
import { appState, proposal } from "../../globalState";
import CarpenterProvider from "../CarpenterView/CarpenterProvider";
import { UnitTool } from "./UnitTools";
import { currencySymbolByLocation } from "./room_unit";
import HistorySideBar from "./HistorySideBar";
import { searchProposal } from "./hooks/searchFirebase";
searchProposal();
function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

function toCurrency(number) {
  return number?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") || 0;
}
const WizardForm = ({
  showItems,
  rent,
  setRent,
  shop,
  setShop,
  ride,
  numOfUnit,
  setRide,
  separatePrinter,
  setSeparatePrinter,
  separateShop,
  setSeparateShop,
  typeOfProperty,
  setTypeOfProperty,
  typeOfTemplate,
  setTypeOfTemplate,
  onChangeBuildingName,
  onChangeNumOfUnit,

  onCreateLinkPress,
  buildingName,
  link,
  location,
  setLocation,
  removeMonitor,
  setRemoveMonitor,
  PDFMode,
  setPDFMode,
  onSaveProposal,
  onLogoChange,
  onRoomSimulationChange,
  onColorClick,
  onRideSimulationChange,
}) => {
  const appStateSnapshot = useSnapshot(appState);
  const proposalSnapshot = useSnapshot(proposal);
  const { templates } = useSelector(mapStateToProps);
  const [open, setOpen] = React.useState(false);
  const [isCarpentry, setIsCarpentry] = React.useState(false);
  const classes = useStyles();
  const { currentLocation, setCurrentLocation } = useRideUnitContext();
  const handleChange = (event) => {
    setLocation(event.target.value);
    setCurrentLocation(event.target.value);
  };

  const handleClick = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const createTypeOfPropertyList = () => {
    const order = ["residential", "student_housing", "custom_types"];
    return (
      templates &&
      Object.keys(templates)
        .filter((key) => {
          const location = key.split("|")[1].split(" ");
          return location.includes(currentLocation.toLowerCase());
        })
        .sort((a, b) => {
          return (
            order.indexOf(a.split("|")[0]) - order.indexOf(b.split("|")[0])
          );
        })
        .map((key) => {
          return (
            <option key={key} style={{ color: "#2D5566" }} value={key}>
              {key.split("|")[0].replace("_", " ")}
            </option>
          );
        })
    );
  };

  const lastEdit = () => {
    if (proposalSnapshot.editors.length === 0) {
      return;
    }
    const lastEditorIndex = proposalSnapshot.editors.length;
    const lastEditDate = new Date(
      proposalSnapshot.editors[lastEditorIndex - 1].timestamp.seconds * 1000
    );
    const currentDate = new Date();
    const diff = currentDate.getTime() - lastEditDate.getTime();
    const diffInDays = Math.ceil(diff / (1000 * 3600 * 24));

    if (diffInDays === 1) {
      return "Today";
    } else {
      return diffInDays + " Days ago.";
    }
  };
  const createTypeOfTemplate = () => {
    if (!typeOfProperty) {
      return null;
    }
    const isOldTemplate = !typeOfProperty.split("|")[1];
    if (isOldTemplate) {
      typeOfProperty += "|" + location;
    }
    return (
      typeOfProperty &&
      templates[typeOfProperty] &&
      Object.keys(templates[typeOfProperty])
        .filter((e) => e !== "ride")
        .map((key) => {
          return (
            <option key={key} style={{ color: "#2D5566" }} value={key}>
              {key}
            </option>
          );
        })
    );
  };

  const _renderRadio = ({ res, label }) => {
    return (
      <FormControlLabel
        value={res}
        control={
          <Radio
            className={classes.root}
            disableRipple
            color="default"
            checkedIcon={<span className={classes.checkedIcon} />}
            icon={<span className={classes.icon} />}
          />
        }
        label={label}
      />
    );
  };

  // helpers const fot the pair Label & Input in the forms
  // 1 cost to role them all (1/3)
  const firstWrapperPairWidth = 330;
  const secondWrapperPairWidth = 250;
  const thirdWrapperPairWidth = 260;
  const toggleSpacer = 14;

  return (
    <>
      <Wrapper>
        <FormWrapper>
          <FormSectionTopic>Create Unit</FormSectionTopic>
          <Rows>
            <Columns>
              <LabelAndInput width={firstWrapperPairWidth}>
                <PlaceHolder>Building Name</PlaceHolder>
                <Input
                  type="text"
                  value={buildingName}
                  placeholder="Building Name"
                  name="Building Name"
                  onChange={(event) => {
                    onChangeBuildingName(event.target.value);
                    proposal.buildingName = event.target.value;
                  }}
                  width={168}
                />
              </LabelAndInput>

              <LabelAndInput width={firstWrapperPairWidth}>
                <PlaceHolder>Country</PlaceHolder>
                <Input
                  type="text"
                  value={proposalSnapshot.proposalCountry}
                  placeholder="country"
                  name="country"
                  onChange={(event) => {
                    proposal.proposalCountry = event.target.value;
                  }}
                  width={168}
                />
              </LabelAndInput>

              <LabelAndInput width={firstWrapperPairWidth}>
                <p />
                <ParamWrapperRadio>
                  <FormControl component="fieldset">
                    <RadioGroup
                      row
                      aria-label="Location"
                      name="Location1"
                      value={location}
                      onChange={handleChange}
                    >
                      {_renderRadio({ res: "us", label: "US" })}
                      {_renderRadio({ res: "eu", label: "EU" })}
                      {_renderRadio({ res: "uk", label: "UK" })}
                      {_renderRadio({ res: "il", label: "IL" })}
                    </RadioGroup>
                  </FormControl>
                </ParamWrapperRadio>
              </LabelAndInput>

              <Divider />

              <LabelAndInput width={firstWrapperPairWidth}>
                <PlaceHolder>Type of property</PlaceHolder>
                <Select
                  value={typeOfProperty}
                  onChange={(event) => {
                    event.target.value !== "null" &&
                      setTypeOfProperty(event.target.value);
                  }}
                  img={dropdown}
                  name="Type of property"
                  style={{ width: 168 }}
                >
                  <option value="null" defaultValue="selected">
                    property
                  </option>
                  {createTypeOfPropertyList()}
                </Select>
              </LabelAndInput>

              <LabelAndInput width={firstWrapperPairWidth}>
                <PlaceHolder>Template</PlaceHolder>
                <Select
                  value={typeOfTemplate}
                  onChange={(event) => setTypeOfTemplate(event.target.value)}
                  img={dropdown}
                  name="Choose a template"
                  style={{ width: 168 }}
                >
                  <option value="null" defaultValue="selected">
                    Choose a template
                  </option>
                  {createTypeOfTemplate()}
                </Select>
              </LabelAndInput>

              <Divider />

              <LabelAndInput width={firstWrapperPairWidth}>
                <PlaceHolder>Numbers of units</PlaceHolder>
                <Input
                  width={168}
                  value={numOfUnit}
                  type="number"
                  placeholder="Numbers of units"
                  name="Numbers of units"
                  onChange={(event) => onChangeNumOfUnit(event.target.value)}
                />
              </LabelAndInput>

              {link && (
                <Link
                  onClick={async () => {
                    await navigator.clipboard.writeText(
                      link.replaceAll(" ", "__")
                    );
                    handleClick();
                  }}
                >
                  {link.replaceAll(" ", "__")}
                </Link>
              )}
              <Snackbar
                open={open}
                autoHideDuration={6000}
                onClose={handleClose}
              >
                <Alert onClose={handleClose} severity="success">
                  Link copied to Clipboard
                </Alert>
              </Snackbar>
            </Columns>
            <div style={{ width: "40px", height: "90%" }} />

            <Columns>
              <ParamWrapper>
                <IOSSwitch
                  checked={rent}
                  onChange={(value) => {
                    setRent(value.target.checked);
                  }}
                  name="checkRent"
                />
                <ParamTitle checked={rent}>Rent</ParamTitle>
              </ParamWrapper>

              <Divider h={toggleSpacer} />

              <ParamWrapper>
                <IOSSwitch
                  checked={shop}
                  onChange={(value) => {
                    setShop(value.target.checked);
                  }}
                  name="checkShop"
                />
                <ParamTitle checked={shop}>Shop</ParamTitle>
              </ParamWrapper>

              <Divider h={toggleSpacer} />

              <ParamWrapper>
                <IOSSwitch
                  checked={ride}
                  onChange={(value) => {
                    setRide(value.target.checked);
                  }}
                  name="checkShop"
                />
                <ParamTitle checked={ride}>Ride</ParamTitle>
              </ParamWrapper>

              <Divider h={toggleSpacer} />

              <ParamWrapper>
                <IOSSwitch
                  checked={separateShop}
                  onChange={(value) => {
                    setSeparateShop(value.target.checked);
                  }}
                  name="checkShop"
                />
                <ParamTitle checked={separateShop}>Separate Shop</ParamTitle>
              </ParamWrapper>

              <Divider h={toggleSpacer} />

              <ParamWrapper>
                <IOSSwitch
                  checked={proposalSnapshot.separatePrinter}
                  onChange={(value) => {
                    proposal.separatePrinter = value.target.checked;
                  }}
                  name="checkShop"
                />
                <ParamTitle checked={proposalSnapshot.separatePrinter}>
                  Separate Printer
                </ParamTitle>
              </ParamWrapper>

              <Divider h={toggleSpacer} />

              {showItems && (
                <ParamWrapper>
                  <IOSSwitch
                    checked={removeMonitor}
                    onChange={(value) => {
                      setRemoveMonitor(value.target.checked);
                    }}
                    name="Remove Monitor"
                  />
                  <ParamTitle checked={removeMonitor}>
                    Remove Monitor{" "}
                  </ParamTitle>
                </ParamWrapper>
              )}
            </Columns>
          </Rows>

          <Divider h={55} />

          {/* TODO: get the props here */}
          {showItems && rent && (
            <UnitTool
              buildingName={buildingName}
              onLogoChange={onLogoChange}
              onRoomSimulationChange={onRoomSimulationChange}
              onColorClick={onColorClick}
              ride={ride}
              onRideSimulationChange={onRideSimulationChange}
            />
          )}
        </FormWrapper>

        <FormWrapper>
          <FormSectionTopic>Offer</FormSectionTopic>

          <LabelAndInput width={secondWrapperPairWidth}>
            <PlaceHolder>Subscription</PlaceHolder>
            <InputWithLable
              width={118}
              value={toCurrency(proposalSnapshot.serviceFee)}
              placeholder="Service fee before discount"
              name="Service fee before discount"
              onChange={(event) => {
                let number = String(event.target.value);
                if (number.length > 1 && number[0] === "0") {
                  number = number.slice(1);
                }
                const withoutCommas = number.replace(/,/g, "");

                return (proposal.serviceFee = withoutCommas);
              }}
            />
            <InputLable>12 months</InputLable>
          </LabelAndInput>

          <LabelAndInput width={secondWrapperPairWidth}>
            <p />
            <InputWithLable
              width={118}
              value={toCurrency(
                Math.floor(proposalSnapshot.serviceFee * 0.9 || 0)
              )}
              placeholder="Service fee"
              name="Service fee"
              disabled
            />
            <InputLable>24 months</InputLable>
          </LabelAndInput>

          <LabelAndInput width={secondWrapperPairWidth}>
            <p />
            <InputWithLable
              width={118}
              value={toCurrency(
                Math.floor(proposalSnapshot.serviceFee * 0.8 || 0)
              )}
              placeholder="Service fee"
              name="Service fee"
              disabled
            />
            <InputLable>36 months</InputLable>
          </LabelAndInput>

          <LabelAndInput width={secondWrapperPairWidth}>
            <PlaceHolder>Setup</PlaceHolder>
            <InputWithLable
              width={118}
              value={toCurrency(proposalSnapshot.setupFeeBeforeDiscount)}
              type="text"
              placeholder="Setup fee before discount"
              name="Setup fee before discount"
              onChange={(event) => {
                let number = String(event.target.value);
                if (number.length > 1 && number[0] === "0") {
                  number = number.slice(1);
                }
                const withoutCommas = number.replace(/,/g, "");

                return (proposal.setupFeeBeforeDiscount = withoutCommas);
              }}
            />
            <InputLable>Before discount</InputLable>
          </LabelAndInput>

          <LabelAndInput width={secondWrapperPairWidth}>
            <p />
            <InputWithLable
              width={118}
              value={toCurrency(proposalSnapshot.setupFee)}
              type="text"
              placeholder="Setup fee"
              name="Setup fee"
              onChange={(event) => {
                let number = String(event.target.value);
                if (number.length > 1 && number[0] === "0") {
                  number = number.slice(1);
                }
                const withoutCommas = number.replace(/,/g, "");

                return (proposal.setupFee = withoutCommas);
              }}
            />
            <InputLable>After discount</InputLable>
          </LabelAndInput>

          <LabelAndInput width={secondWrapperPairWidth}>
            <PlaceHolder>Rev share</PlaceHolder>
            <InputWithLable
              width={118}
              value={proposalSnapshot.ownerRevenue}
              type="text"
              max={100}
              placeholder="Owner Revenue %"
              name="Owner Revenue %"
              autoComplete="off"
              onChange={(event) => {
                if (event.target.value <= 100 && event.target.value >= 0) {
                  proposal.ownerRevenue = event.target.value;
                }
              }}
            />
            <InputLable>Owner</InputLable>
            <PercentAdded>%</PercentAdded>
          </LabelAndInput>

          <LabelAndInput width={secondWrapperPairWidth}>
            <PlaceHolder> </PlaceHolder>
            <InputWithLable
              width={118}
              value={100 - proposalSnapshot.ownerRevenue}
              type="text"
              autoComplete="off"
              placeholder="Owner Revenue %"
              name="Owner Revenue %"
              disabled
            />
            <InputLable>TULU</InputLable>
            <PercentAdded>%</PercentAdded>
          </LabelAndInput>

          <LabelAndInput width={secondWrapperPairWidth}>
            <p />
            <ParamWrapper>
              <IOSSwitch
                checked={proposalSnapshot.hideIntroduction}
                onChange={(value) => {
                  proposal.hideIntroduction = value.target.checked;
                }}
                name="Hide Introduction"
                autoComplete="off"
              />
              <ParamTitle checked={proposalSnapshot.hideIntroduction}>
                Hide Introduction
              </ParamTitle>
            </ParamWrapper>
          </LabelAndInput>

          <LabelAndInput width={secondWrapperPairWidth}>
            <p />
            <ParamWrapper>
              <IOSSwitch
                checked={proposalSnapshot.hide12months}
                autoComplete="off"
                onChange={(value) => {
                  proposal.hide12months = value.target.checked;
                }}
                name="Hide 12 months"
              />
              <ParamTitle checked={proposalSnapshot.hide12months}>
                Hide 12 months
              </ParamTitle>
            </ParamWrapper>
          </LabelAndInput>
        </FormWrapper>

        <FormWrapper>
          <FormSectionTopic>Unit Costs</FormSectionTopic>

          <FormSectionSubTopic>Manufacturing</FormSectionSubTopic>

          <LabelAndInput width={thirdWrapperPairWidth}>
            <PlaceHolder>Unit Price</PlaceHolder>
            <RightTogether>
              {currencySymbolByLocation(location)}
              <Input
                width={93}
                value={proposalSnapshot.unitPrice}
                type="number"
                placeholder="unit price"
                autoComplete="off"
                name="unit price"
                onChange={(e) => (proposal.unitPrice = Number(e.target.value))}
              />
            </RightTogether>
          </LabelAndInput>

          <LabelAndInput width={thirdWrapperPairWidth}>
            <PlaceHolder>Ride Racks Price</PlaceHolder>
            <RightTogether>
              {currencySymbolByLocation(location)}
              <Input
                width={93}
                value={proposalSnapshot.rideRacksPrice}
                type="number"
                placeholder="Ride Racks Price"
                name="Ride Racks Price"
                autoComplete="off"
                onChange={(e) =>
                  (proposal.rideRacksPrice = Number(e.target.value))
                }
              />
            </RightTogether>
          </LabelAndInput>

          <LabelAndInput width={thirdWrapperPairWidth}>
            <PlaceHolder>Shipment Pricing</PlaceHolder>
            <RightTogether>
              {currencySymbolByLocation(location)}
              <Input
                width={93}
                value={proposalSnapshot.shipmentPrice}
                type="number"
                placeholder="Shipment Pricing"
                autoComplete="off"
                name="Shipment Pricing"
                onChange={(e) =>
                  (proposal.shipmentPrice = Number(e.target.value))
                }
              />
            </RightTogether>
          </LabelAndInput>

          <LabelAndInput width={thirdWrapperPairWidth}>
            <PlaceHolder>Installation Pricing</PlaceHolder>
            <RightTogether>
              {currencySymbolByLocation(location)}
              <Input
                width={93}
                value={proposalSnapshot.installationPricing}
                type="number"
                placeholder="Installation Pricing"
                name="Installation Pricing"
                autoComplete="off"
                onChange={(e) =>
                  (proposal.installationPricing = Number(e.target.value))
                }
              />
            </RightTogether>
          </LabelAndInput>

          <FormSectionSubTopic>Products</FormSectionSubTopic>

          <LabelAndInput width={thirdWrapperPairWidth}>
            <PlaceHolder>Total Retail Cost</PlaceHolder>
            <RightTogether>
              {currencySymbolByLocation(location)}
              <Input
                width={93}
                autoComplete="off"
                value={Math.floor(proposalSnapshot.totalRetailCost)}
                type="number"
                placeholder="Total Retail Cost"
                name="Total Retail Cost"
                disabled
              />
            </RightTogether>
          </LabelAndInput>

          <LabelAndInput width={thirdWrapperPairWidth}>
            <PlaceHolder>TULU Pay</PlaceHolder>
            <RightTogether>
              {currencySymbolByLocation(location)}
              <Input
                width={93}
                type="number"
                autoComplete="off"
                placeholder="TULU Pay"
                name="TULU Pay"
                value={Math.floor(proposalSnapshot.tuluPay)}
                disabled
              />
            </RightTogether>
          </LabelAndInput>

          <LabelAndInput width={thirdWrapperPairWidth}>
            <div style={{ position: "relative", marginTop: "-15px" }}>
              <PlaceHolder>Total Client Cost</PlaceHolder>
              <PlaceHolder30Off>30% OFF</PlaceHolder30Off>
            </div>
            <RightTogether>
              {currencySymbolByLocation(location)}
              <Input
                width={93}
                type="number"
                autoComplete="off"
                placeholder="TULU Pay"
                name="TULU Pay"
                value={Math.floor(proposalSnapshot.totalRetailCost * 0.7)}
                disabled
                soft={true}
              />
            </RightTogether>
          </LabelAndInput>

          <LabelAndInput width={secondWrapperPairWidth}>
            <FormSectionTopic>Total</FormSectionTopic>
            <FormSectionTopic>
              ${" "}
              {Math.floor(
                proposalSnapshot.unitPrice +
                  proposalSnapshot.rideRacksPrice +
                  proposalSnapshot.shipmentPrice +
                  proposalSnapshot.installationPricing +
                  proposalSnapshot.tuluPay
              )}
            </FormSectionTopic>
          </LabelAndInput>
        </FormWrapper>
      </Wrapper>

      <FormFooter>
        <LastEditOn
          onClick={() => {
            appState.sideBarOpen = true;
          }}
        >
          {proposalSnapshot.editors.length > 0 && `Last edit was ${lastEdit()}`}
        </LastEditOn>
        <HistorySideBar />

        <CtaButtons>
          <CreateLink
            style={{ backgroundColor: PDFMode && "grey" }}
            onClick={!PDFMode && onCreateLinkPress}
            disabled={
              !buildingName ||
              !showItems ||
              proposalSnapshot.proposalApproved ||
              !proposalSnapshot.setupFee
            }
          >
            {PDFMode ? appStateSnapshot.uploadStatus : "Save and Create link"}
          </CreateLink>

          <CreateLink
            style={{ backgroundColor: PDFMode && "grey" }}
            disabled={!buildingName || !showItems}
            onClick={() => {
              const pw = prompt("what is the admin password");
              if (pw === "admin1234") {
                proposal.proposalApproved = !proposal.proposalApproved;
              }
              onSaveProposal();
            }}
          >
            {proposal.proposalApproved
              ? "Proposal Approved \n and is \n Read only"
              : "Save and Approve Proposal"}
          </CreateLink>

          <CreateLink
            onClick={() => {
              setIsCarpentry(!isCarpentry);
              setPDFMode(true);
            }}
            disabled={!proposalSnapshot.proposalApproved || PDFMode}
          >
            {PDFMode ? "Rendering PDF..." : "Create Carpentry"}
          </CreateLink>
        </CtaButtons>
      </FormFooter>
      {isCarpentry && (
        <div style={{ display: "none" }}>
          {" "}
          <CarpenterProvider id={buildingName} />
        </div>
      )}
    </>
  );
};

export { WizardForm };

const mapStateToProps = ({ ItemsReducer }) => {
  return {
    items: ItemsReducer.items,
    templates: ItemsReducer.templates,
  };
};

const Wrapper = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: center;
  width: 800px;
  margin: 0 auto;
  gap: 15px;
  transform: scale(0.8) translateY(-65px);
  margin-top: -64px;
`;

const FormWrapper = styled.div`
  //transform: scale(0.75);
  width: 100%;
  box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.16);
  background-color: #f9f7f7;
  //align-items: center;
  display: flex;
  padding: 31px 48px 0px;
  flex-direction: column;
`;

const Rows = styled.div`
  width: 100%;
  display: flex;
  position: relative;
  flex-direction: row;
`;

const Divider = styled.div`
  height: ${(props) => (props.h ? props.h : 10)}px;
`;

const Columns = styled.div`
  display: flex;
  flex-direction: column;
`;

const PlaceHolder = styled.span`
  font-family: Lexend, serif;
  font-size: 16px;
  //text-align: center;
  color: #4b4b4b;
`;

const PlaceHolder30Off = styled(PlaceHolder)`
  position: absolute;
  left: 0;
  top: 20px;
  font-size: 12px;
`;

const Input = styled.input`
  color: #2d5566;
  opacity: ${(props) => (props.soft ? "0.5" : "1")};
  padding: 11px;
  border: 1px solid #dcdcdc;
  border-radius: 5px;
  width: ${(props) => props.width && `${props.width}px`};
  position: relative;

  &:disabled {
    background: #fff;
    cursor: not-allowed;
  }

  &::-webkit-input-placeholder {
    color: #2d5566;
    padding-left: 0.25em;
  }
`;

const InputWithLable = styled(Input)`
  padding: 16px 11px 6px 11px;
`;

const InputLable = styled.div`
  position: absolute;
  left: 143px;
  top: 7px;
  color: #707070;
  font-size: 6px;
`;

const Select = styled.select`
  -moz-appearance: none;
  -webkit-appearance: none;
  appearance: none;
  width: 233px;
  background: white url(${({ img }) => img}) no-repeat 95% 50%;
  background-size: 15px;
  color: #707070;
  padding: 10px;
  font-family: Manrope, serif;
  border: 1px solid #dcdcdc;
  border-radius: 5px;

  &::-webkit-input-placeholder {
    color: #2d5566;
    padding-left: 0.25em;
  }
`;

const ParamWrapper = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-items: center;
  width: 207px;
`;

const ParamWrapperRadio = styled(ParamWrapper)`
  margin-right: -12px;
  width: fit-content;
`;

const CreateLink = styled.button`
  background-color: ${(props) => (props.disabled ? "grey" : "#13647b")};
  border: none;
  color: white;
  padding: 10px 32px;
  text-align: center;
  text-decoration: none;
  font-size: 16px;
  cursor: pointer;
  position: relative;
  width: fit-content;
  border-radius: 4px;
  //margin-top: 15px;
  margin-left: 25px;

  &:hover {
    color: white;
  }
`;

const Link = styled.a`
  margin-top: 10px;
  cursor: pointer;
  color: blue;
`;

const ParamTitle = styled.div`
  font-size: 16px;
  color: ${({ checked }) => (checked ? "#2b2b2b" : "#9a9a9a")};
  padding: 10px;
  flex: 1;
  //width: 200px;
`;

const FormSectionTopic = styled.h2`
  width: 82px;
  height: 18px;
  margin: 0 3px 51px 0;
  font-family: Lexend;
  font-size: 14px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 3.57;
  letter-spacing: normal;
  text-align: left;
  color: #707070;
  text-align: left;
`;

const FormSectionSubTopic = styled.h3`
  text-align: left;
  font-family: Lexend;
  font-size: 12px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  letter-spacing: normal;
  text-align: left;
  color: #707070;
  padding-bottom: 6px;
  border-bottom: 2px solid #707070;
  width: min-content;
`;

const LabelAndInput = styled.div`
  width: ${(props) => props.width}px;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-items: center;
  justify-content: space-between;
  padding-bottom: 10px;
  position: relative;
`;

const PercentAdded = styled.div`
  position: absolute;
  right: 15px;
`;

const RightTogether = styled.div`
  width: min-content;
  display: flex;
  align-items: center;
  gap: 5px;
`;

const FormFooter = styled.div`
  width: 1130px;
  margin: 20px auto 50px auto;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: space-between;
  align-items: center;
  position: relative;
  top: -110px;
`;

const LastEditOn = styled.div`
  font-size: 14px;
  text-align: left;
  color: #707070;
  text-decoration: underline;
  width: fit-content;
`;

const CtaButtons = styled.div`
  display: flex;
  justify-content: center;
`;

const useStyles = makeStyles({
  root: {
    "&:hover": {
      backgroundColor: "transparent",
    },
  },
  icon: {
    borderRadius: "50%",
    width: 16,
    height: 16,
    boxShadow:
      "inset 0 0 0 1px rgba(16,22,26,.2), inset 0 -1px 0 rgba(16,22,26,.1)",
    backgroundColor: "#f5f8fa",
    backgroundImage:
      "linear-gradient(180deg,hsla(0,0%,100%,.8),hsla(0,0%,100%,0))",
    "$root.Mui-focusVisible &": {
      outline: "2px auto rgba(19,124,189,.6)",
      outlineOffset: 2,
    },
    "input:hover ~ &": {
      backgroundColor: "#ebf1f5",
    },
    "input:disabled ~ &": {
      boxShadow: "none",
      background: "rgba(206,217,224,.5)",
    },
  },
  checkedIcon: {
    backgroundColor: "#2D5566",
    backgroundImage:
      "linear-gradient(180deg,hsla(0,0%,100%,.1),hsla(0,0%,100%,0))",
    borderRadius: "50%",
    width: 16,
    height: 16,
    boxShadow:
      "inset 0 0 0 1px rgba(16,22,26,.2), inset 0 -1px 0 rgba(16,22,26,.1)",
    "$root.Mui-focusVisible &": {
      outline: "2px auto rgba(19,124,189,.6)",
      outlineOffset: 2,
    },
    "input:disabled ~ &": {
      boxShadow: "none",
      background: "rgba(206,217,224,.5)",
    },
    "&:before": {
      display: "block",
      width: 16,
      height: 16,
      backgroundImage: "radial-gradient(#fff,#fff 28%,transparent 32%)",
      content: '""',
    },
    "input:hover ~ &": {
      backgroundColor: "#2D5566",
    },
  },
});
